import { render, staticRenderFns } from "./NotServiceOldReason.vue?vue&type=template&id=ad077622&scoped=true"
import script from "./NotServiceOldReason.vue?vue&type=script&lang=js"
export * from "./NotServiceOldReason.vue?vue&type=script&lang=js"
import style0 from "./NotServiceOldReason.vue?vue&type=style&index=0&id=ad077622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad077622",
  null
  
)

export default component.exports